import {
  createBlocContext,
  createBlocProvider
} from "@kernel/frontend-react-app";
import { useContext } from "react";
import { StatsBloc } from "./StatsBloc";

export const StatsContext = createBlocContext<StatsBloc>();

export function useStatsContext() {
  const ctx = useContext(StatsContext);
  return ctx;
}

export const StatsBlocProvider = createBlocProvider<StatsBloc>(
  StatsBloc.create(),
  StatsContext
);
